import React from 'react';
import Box from '../../../../Box/Box';
import VStack from '../../../../VStack/VStack';

// Subcomponents
import { SiteKitHeadlineAnchor } from './SiteKitHeadlineAnchor/SiteKitHeadlineAnchor';

// Exports
interface SiteKitHeadlinesProps {
  children: React.ReactNode;
}
const SiteKitHeadlines = ({ children }: SiteKitHeadlinesProps) => (
  <Box horizontal="gutter" bottom="medium">
    <VStack spacing="small">{children}</VStack>
  </Box>
);
SiteKitHeadlines.Anchor = SiteKitHeadlineAnchor;

SiteKitHeadlines.displayName = 'SiteKit.Sidebar.Headlines';

export { SiteKitHeadlines, SiteKitHeadlinesProps };
